import React, { Component } from 'react';
import "./Contact.css";
import { Link } from "react-router-dom"
import { useSpring, animated } from '@react-spring/web'
import { useState, useEffect } from 'react';
import {motion} from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-regular-svg-icons';
import { faLinkedin, faInstagramSquare } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import background5 from '../images/General Presentation_page-0005_00000_00000.png';
import emailjs from "emailjs-com";

function Contact(){

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return; // Prevent duplicate submissions

  setIsSubmitting(true);
  try {
    const response = await emailjs.send(
      "service_m8jualr",
      "template_rirxmgc",
      {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
      },
      "haeRNQRr32rzPKzHO"
    );

    if (response.status === 200) {
      setResponseMessage("Your message has been sent successfully!");
    } else {
      setResponseMessage("Failed to send your message. Please try again.");
    }
  } catch (error) {
    console.error("Error sending email:", error);
    setResponseMessage("An error occurred. Please try again later.");
  } finally {
    setIsSubmitting(false); // Re-enable the button
  }
};

  const [propsSlideRightOp] = useSpring(
    () => ({
      from: { opacity: 0, y: '-100%' },
      to: { opacity: 1 , y: '0%' },
      delay: 500
    }),
    []
  )

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // After the component is mounted, set isVisible to true
    setIsVisible(true);
    emailjs.init({
      publicKey: "haeRNQRr32rzPKzHO",
    });

    // Cleanup function for when the component is about to unmount
    return () => {
      setIsVisible(false);
    };
  }, []);
  
    return (
    <div> 
         
          <motion.div   initial={{opacity:0, transition: { duration: 0.1}}} 
                        animate={{opacity:100, transition: { duration: 0.5, delay:0 , ease: "easeInOut"}}} 
                        exit={{opacity:0 , transition: { duration:0.5, ease: "easeInOut" }}} 
                        className={`container-fluid my-body container-slides ${isVisible ? 'visible' : ''}`}>
                <motion.img
                  src={background5}
                  alt={`Slide whyUs`}
                  className="background"
                  initial={{opacity:0, scale:0 , transition: { duration: 0.1}}} 
                  animate={{opacity:100, scale:1 , transition: { duration: 0.5, delay:0.7 , ease: "easeInOut"}}} 
                  exit={{opacity:0, scale:0 , transition: { duration:0.5, ease: "easeInOut" }}} 
                 />
                 <br/><br/>
          </motion.div>
          <br/><br/><br/><br/>
    </div>
    );
    
  }
export default Contact;